export const setToken = (key, value) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(key, value);
  }
};

export const getToken = (key = 'penatoken') => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem(key);
  }
  return null;
};

export const removeToken = (key = 'penatoken') => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(key);
  }
};

export const isAuthenticated = () => {
  return !!getToken();
};